import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import FlagstoneTheme from '../../../Config/flagstoneTheme';


export default function DeleteDialog(props) {

    const classes = useStyles();

    function PaperComponent(props) {
        return (
            <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
                <Paper {...props} />
            </Draggable>
        );
    }

    return (

        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >    <div className={classes.headerIcon}> <img className={classes.menuIcon} alt="delete" src={process.env.PUBLIC_URL + '/img/trashIcon.svg'}></img>
            </div>
            <DialogTitle className={classes.dialogTitle} id="draggable-dialog-title">
                {props.dialogTitle}
            </DialogTitle>
            <DialogContent >
                <DialogContentText className={classes.dialogContext}>
                    {props.dialogContext}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.cancelButton} autoFocus onClick={props.closeDialog} >
                        CANCEL
              </Button>
                    <Button className={classes.deleteButton} autoFocus onClick={props.action} >
                        DELETE
                 </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "520px !important",
        height: "420px !important",
        margin: "auto"
    },
    buttons: {
        width: "520px",
        textAlign: "center"
    },
    cancelButton: {
        border: "1px solid " + FlagstoneTheme.palette.primary.main,
        color: FlagstoneTheme.palette.primary.main,
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        margin: "3px",
        width: "100px",
        marginBottom: "20px"

    },
    deleteButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        backgroundColor: "#D84949",
        '&:hover': {
            backgroundColor: "#D84949",
        },
        margin: "3px",
        width: "100px",
        marginBottom: "20px"
    },   
   
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "0px",
        cursor: 'move'
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center"
    },
    headerIcon: {
        height: "80px",
        width: "100%",
        marginTop: "20px",
        textAlign: "center",
        padding: "20px",
        boxSizing: "border-box"
    }
}));
